module.exports = __webpack_public_path__ + "img/mustread.a25bc322.jpg";